import angular from "angular";

angular
    .module('app')
    .component('videogularPlayer', {
        template: require('./videogular-player.html'),
        controller: ['$sce', '$timeout',controller],
        bindings: {
            video: '<'
        }
    });

function controller($sce, $timeout) {

    let $ctrl = this;

    $ctrl.theme = '/videogular/videogular.min.css';

    $ctrl.$onInit = function () {
        $ctrl.source = [
            {src: $sce.trustAsResourceUrl($ctrl.video.url), type: "video/mp4"},
        ];
    };

    $timeout(function () {
        $ctrl.qualitySources = [
            {
                name: '720p',
                sources: [
                    {
                        src: $sce.trustAsResourceUrl($ctrl.video.lg_path),
                        type: "video/mp4"
                    }
                ],
                dashIndex: 2
            },
            {
                name: '480p',
                sources: [
                    {
                        src: $sce.trustAsResourceUrl($ctrl.video.md_path),
                        type: "video/mp4"
                    }
                ],
                dashIndex: 1
            },
            {
                name: '360p',
                sources: [
                    {
                        src: $sce.trustAsResourceUrl($ctrl.video.sm_path),
                        type: "video/mp4"
                    }
                ],
                dashIndex: 0
            },
            {
                name: 'Auto',
                sources: [
                    {
                        src: $ctrl.video.mpd_path
                    }
                ]
            }
        ];
        $ctrl.currentQualitySource = $ctrl.qualitySources[$ctrl.qualitySources.length - 1];
    }, 2);

}
